import { HttpContext, HttpContextToken } from '@angular/common/http';

/**
 * Set on a request that must NOT open the "Plan Limit Reached" dialog when the plan does not include the feature.
 * The caller handles the refusal itself (for example Quick Search leaves that source out and says so in a quiet line).
 * Every other request keeps the dialog.
 */
export const QUIET_PLAN_BLOCK = new HttpContextToken<boolean>(() => false);

export function quietPlanBlockContext(): HttpContext {
  return new HttpContext().set(QUIET_PLAN_BLOCK, true);
}

/** True when the server refused because the plan does not include the feature (403 PLAN_FEATURE_DISABLED). */
export function isPlanFeatureBlock(err: any): boolean {
  return err?.status === 403 && err?.error?.code === 'PLAN_FEATURE_DISABLED';
}
